import { makeStyles } from '@material-ui/core/styles';

const useCustomComponentStyles = makeStyles((theme) => {

    const style = {};	
    style['flex-auto'] = {
        flex: 'auto',
    }

    style['ml_10'] = {
        marginLeft: '10px',
    }
    return style;
})

export default useCustomComponentStyles;